import React, { useState } from 'react';
import { Card, Typography } from 'antd';
import moment from 'moment';
import { useQuery } from 'react-query';

import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import RouterLink from 'components/RouterLink';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  getScoringListByCriteria,
  GetScoringListByCriteriaParams,
  ScoringListSearch,
} from 'services/scoring';
export type ScoringListModalProps = {
  onSelect?: (item: ScoringListSearch) => void;
};
const ScoringListModal = ({ onSelect }: ScoringListModalProps) => {
  const [searchParams, setSearchParams] =
    useState<GetScoringListByCriteriaParams>({
      clientname: '',
      clientreference: '',
      ctreference: '',
      decisioncode: '',
      decisionlevel: '',
      decisiontype: '',
      propreference: '',
      status: '',
      scoreference: '',
    });

  const { data: scoringList, isFetching } = useQuery(
    ['getScoringListByCriteria', searchParams],
    () => getScoringListByCriteria(searchParams).then((res) => res.list || []),
    { refetchOnMount: false }
  );

  const onSearch = (values: GetScoringListByCriteriaParams) => {
    setSearchParams((prev) => ({ ...prev, ...values }));
  };

  const columns: DataGridColDef<ScoringListSearch>[] = [
    {
      comcode: 'result.scoreference',
      dataIndex: 'scoreference',
      render: (scoreference, record) => {
        if (onSelect) {
          return (
            <Typography.Link onClick={() => onSelect(record)}>
              {scoreference}
            </Typography.Link>
          );
        } else
          <RouterLink to={`/scoring/${record.scoid}`}>
            {scoreference}
          </RouterLink>;
      },
      fixed: 'left',
      width: 120,
    },
    {
      comcode: 'result.scostatus',
      dataIndex: 'scostatus',
      filtrable: 'status',
      filterComponent: <ParListSelect parcode="STATUS" />,
      width: 150,
    },
    {
      comcode: 'result.scodate',
      dataIndex: 'scodate',
      width: 100,
      render: (text, record) => moment(text).format('YYYY-MM-DD'),
    },
    {
      comcode: 'result.scodecisioncodelabel',
      dataIndex: 'scodecisioncodelabel',
      filtrable: 'declevel',
      filterComponent: <ParListSelect parcode="DECLEVEL" />,
      width: 150,
    },
    {
      comcode: 'result.scodecisiontype',
      dataIndex: 'scodecisiontype',
      filtrable: 'dectype',
      filterComponent: <ParListSelect parcode="DECTYPE" />,
      width: 100,
    },
    {
      comcode: 'result.propreference',
      dataIndex: 'propreference',
      filtrable: 'propreference',
      width: 100,
    },
    {
      comcode: 'result.ctreference',
      dataIndex: 'ctreference',
      filtrable: 'ctreference',
      width: 100,
    },

    {
      comcode: 'result.clientname',
      dataIndex: 'clientname',
      filtrable: 'clientname',
      width: 200,
    },
    {
      comcode: 'result.scodecisionlevellabel',
      dataIndex: 'scodecisionlevellabel',
      filtrable: 'declevel',
      filterComponent: <ParListSelect parcode="DECLEVEL" />,
      width: 100,
    },
    {
      comcode: 'result.scolabel',
      dataIndex: 'scolabel',
      width: 200,
    },
    {
      comcode: 'result.scoscore',
      dataIndex: 'scoscore',
      fixed: 'right',
      width: 120,
      align: 'right',
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: 100,
      /*render: (record) => (
        <TasksListPopover
          entityId={record.scoid}
          entityName="SCORING"
          onSuccess={refetch}
        >
          <Button icon={<ArrowsAltOutlined />} size="small" comcode="actions" />
        </TasksListPopover>
      ),*/
    },
  ];

  return (
    <DF.Provider pagcode="scoringlist">
      <Card>
        <DataGrid
          dataSource={scoringList}
          isLoading={isFetching}
          rowKey={(record) => record.scoid}
          columns={columns}
          initialSearchValues={searchParams}
          onSearch={onSearch}
        />
      </Card>
    </DF.Provider>
  );
};

export default ScoringListModal;
